import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconFlame = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="apricot">
      <Path fill={`url(#gradient_${id})`} d="M13.752 3.172c-.002-.076-.085-.126-.15-.087-3.466 2.07-3.402 7.264-3.36 8.205.003.071-.064.121-.129.091-.4-.189-1.547-.899-1.61-2.866-.003-.076-.085-.125-.151-.086C6.346 9.618 5 11.814 5 14.25 5 17.978 8.134 21 12 21s7-3.022 7-6.75c0-5.416-5.12-6.58-5.248-11.078Z"/>
    </IconWithGradient>);
};
